import users from './apiUsers'

export default {
  ...users,
}
